var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleSuperiorError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 46,
    viewBox: "0 0 740 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M739.5 3C739.5 1.62692 738.353 0.500043 736.964 0.500502C594.981 0.547484 483.456 3.88401 371.683 7.22791L370.942 7.25008C258.922 10.6014 146.586 13.9528 3.03644 13.9995C1.64771 14 0.5 15.1271 0.5 16.5V42.4939C0.5 43.8688 1.65082 44.9967 3.04132 44.9938L736.969 43.5061C738.355 43.5033 739.5 42.3771 739.5 41.0061V3Z",
    fill: "white",
    stroke: "#FF4B62",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleSuperiorError);
export default __webpack_public_path__ + "static/media/rectangleSuperiorError.ca04f6f55cc44ebc685adc8894cb8f9a.svg";
export { ForwardRef as ReactComponent };